<template>
  <div class="skeleton-loader" :style="{ width: width, height: height, borderRadius: radius }">
  </div>
</template>
<script setup>
import {ref} from 'vue';
const props = defineProps(['width', 'height', 'radius', 'borderColor', 'leftColor', 'centerColor', 'rightColor'])
const left_Color = ref(props.leftColor || '#323639');
const center_Color = ref(props.centerColor || '#313437')
const right_Color = ref(props.rightColor || '#36393c')
</script>

<style scoped>
.skeleton-loader {
  background: linear-gradient(90deg, v-bind(left_Color) 25%, v-bind(center_Color) 50%,v-bind(right_Color) 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-bottom: 1px solid v-bind(borderColor);
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}
</style>